import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Icon, Form, DatePicker, TimePicker, Input, Tooltip, Button, message } from 'antd';
import applicationCenterService from '../../services/Employee/application-center-service';
import moment from 'moment';
import { Result } from 'antd-mobile';

// import { Link } from 'react-router-dom';
const { TextArea } = Input;
class ApplyAttendance extends React.Component {


    state={
        Management_on_time:null,
        Management_off_time:null,
        on_time:null,
        off_time:null,
    }

    submitApplyModal = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let posts = {
                    ...values
                };
                if (values.attendance_date) {
                    posts.attendance_date = values.attendance_date.format('YYYY-MM-DD')
                }
                if (values.on_time) {
                    posts.on_time = values.on_time.format('HH:mm')
                }
                if (values.off_time) {
                    posts.off_time = values.off_time.format('HH:mm')
                }
              posts.complaint_content=values.complaint_content


                applicationCenterService.ApplyAttendance(posts, res => {
                    if (res.data.Success) {
                        message.success("考勤申诉操作成功 Apply Attendance Success", 4);
                        this.props.form.resetFields();
                    } else {
                        message.error(`考勤申诉操作失败 Apply Attendance Faild：${res.data.Errors[0]}`);
                        
                    }
                }, err => { });
            }
        })
    }

    //获取选择日期的考勤记录
    getAttendanceRecord=value=>{
        if(!value){
            message.error(`请选择考勤日期`);
            return false;
        }
        let gets={
            attendance_date:value.format('YYYY-MM-DD')
        }
        applicationCenterService.fetchAttendanceDetail(gets, res => {
            console.log(res)
            if (res.data.Success) {
                this.setState({
                    Management_on_time:res.data.Object.Management_on_time,
                    Management_off_time:res.data.Object.Management_off_time,
                    on_time:res.data.Object.on_time,
                    off_time:res.data.Object.off_time,
                })
            } else {
                message.error(`${res.data.Errors[0]}`);
                this.props.form.resetFields();
            }
        }, err => { });
    }

    render() {
        return (
            <div className="app-module-item">
                <div className="remindingImportant">考勤申诉 Apply Attendance</div>
                <Form onSubmit={this.submitApplyModal} className="login-form long-label" layout="inline">

                    <div className="Applys ApplyDiv">
                        <Form.Item label={(
                            <span>
                                <Tooltip>
                                    <Icon type="calendar" />
                                </Tooltip>
                                &nbsp;申诉日期 Apply Date
				            </span>
                        )} style={{ float: "left" }}>
                            {this.props.form.getFieldDecorator('attendance_date', {
                                rules: [{ required: true, message: '请输入申诉日期' }],
                            })(<DatePicker style={{ width: "180px" }} onChange={this.getAttendanceRecord} />)}
                        </Form.Item>
                    </div>
                    <div className="ApplyDiv">
                        <Form.Item label={(
                            <span>
                                <Tooltip>
                                    <Icon type="calendar" />
                                </Tooltip>
                                &nbsp;班次时间 Schedule Time
				            </span>
                        )} style={{ float: "left" }}>
                            <TimePicker disabled placeholder="" value={this.state.Management_on_time&&moment(this.state.Management_on_time, 'HH:mm')} format="HH:mm" style={{ width: "170px" }} />
                        </Form.Item>
                        <Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
                            <TimePicker disabled placeholder="" value={this.state.Management_off_time&&moment(this.state.Management_off_time, 'HH:mm')} format="HH:mm" style={{ width: "170px" }} />
                        </Form.Item>
                    </div>
                    <div className="ApplyDiv">
                        <Form.Item label={(
                            <span>
                                <Tooltip>
                                    <Icon type="calendar" />
                                </Tooltip>
                                &nbsp;实际时间 Actual Time
				            </span>
                        )} style={{ float: "left" }}>
                            <TimePicker disabled placeholder="" value={this.state.on_time&&moment(this.state.on_time, 'HH:mm')} format="HH:mm" style={{ width: "170px" }} />
                        </Form.Item>
                        <Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
                            <TimePicker disabled placeholder="" value={this.state.off_time&&moment(this.state.off_time, 'HH:mm')} format="HH:mm" style={{ width: "170px" }} />
                        </Form.Item>
                    </div>
                    <div className="ApplyDiv">
                        <Form.Item label={(
                            <span>
                                <Tooltip>
                                    <Icon type="calendar" />
                                </Tooltip>
                                &nbsp;申诉时间 Apply Time
				            </span>
                        )} style={{ float: "left" }}>
                            {this.props.form.getFieldDecorator('on_time', {
                                rules: [{ required: true, message: '开始时间 Start Time' }],
                                initialValue:this.state.on_time&&moment(this.state.on_time, 'HH:mm')
                            })(<TimePicker disabled={this.state.on_time}   format="HH:mm" style={{ width: "170px" }} />)}
                        </Form.Item>
                        <Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
                            {this.props.form.getFieldDecorator('off_time', {
                                rules: [{ required: true, message: '结束时间 End Time' }],
                                initialValue :this.state.off_time&&moment(this.state.off_time, 'HH:mm')
                            })(<TimePicker disabled={this.state.off_time}    format="HH:mm" style={{ width: "170px" }} />)}
                        </Form.Item>
                    </div>
                    <div className="ApplyDiv">
                        <Form.Item label={(
                            <span>
                                <Tooltip>
                                    <Icon type="file-text" />
                                </Tooltip>
                                &nbsp;申诉描述 Apply Description
				            </span>
                        )}>
                            {this.props.form.getFieldDecorator('complaint_content', {
                            })(<TextArea rows={4} style={{ display: 'block', width: '360px' }} />)}
                        </Form.Item>
                    </div>
                    <div className="ApplySubmit">
                        <Button type="primary" onClick={this.submitApplyModal}>
                            <Icon type="check" />
                            <span>提交 Submit</span>
                        </Button>
                    </div>

                </Form>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = {
}

ApplyAttendance = Form.create()(ApplyAttendance);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ApplyAttendance));


// WEBPACK FOOTER //
// ./src/routes/Employee/ApplyAttendance.js